import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { LocalStorage } from 'app/shared/constants/local-storage.constant';
import { LocalStorageService } from 'app/shared/service/local-storage.service';
import { ToasterService } from 'app/shared/service/toaster.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { UserServiceProxy } from 'shared/service-proxies/services/user.service';
import { LoginDto } from 'shared/service-proxies/models/login-dto.model';
import * as CryptoJS from 'crypto-js';
import { SharedService } from 'app/shared/service/shared.service';
import { Message, MessageService } from 'primeng/api';
import { ResetPasswordInputDto } from 'shared/service-proxies/models/reset-password-input-dto.model';

@Component({
  selector: 'sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SignInComponent implements OnInit {

  loginForm: FormGroup;
  forgetPasswordDialog: boolean = false;
  resetPasswordDialog: boolean = false;
  mailsuccessfully: boolean = false;
  userName: string;
  verficationCode: string;
  resetPasswordInputDto: ResetPasswordInputDto = new ResetPasswordInputDto();
  confirmnewpassword: string;
  inValidVerificationCode: boolean = false;
  inValidUsername: boolean = false;
  severity: any;
  msg: string;
  isAdmin: boolean = false;
  invalid:any;
  errMsg = []
  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _localStorageService: LocalStorageService,
    private _toasterService: ToasterService,
    private _authenticationService: AuthenticationService,
    private sharedSerice: SharedService,
    private _userServiceProxy: UserServiceProxy,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute
  ) {
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }

  returnUrl: string;

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.verficationCode = params.verifycode;
    });
    this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
    if (this.verficationCode) {
      this._localStorageService.deleteAllData();
      this._userServiceProxy.isVerificationCodeValid(this.verficationCode).subscribe(response => {
        if (response.isSuccess) {
          this.resetPasswordDialog = true;
          this.resetPasswordInputDto = new ResetPasswordInputDto();
        } else {
          this.toasterMessage("error", "Reset Password Link is already used or invalid", 10000)
        }
      });
    }
    if (!this.resetPasswordDialog) {
      if (this._authenticationService.isAuthenticated()) {
         this._router.navigate(['dashboard']);
      }
      this.loginForm = this._formBuilder.group({
        mobileno: ['', [Validators.required]],
        password: ['', Validators.required],
        rememberme: [false]
      });

      const storedUsername = this._localStorageService.getData(LocalStorage.USERNAME);
      const storedPassword = this._localStorageService.getData(LocalStorage.PASSWORD);

      if (storedUsername && storedPassword) {
        const username = String(storedUsername);
        const data = String(storedPassword);
        
        try {
          const decryptedPassword = CryptoJS.AES.decrypt(data.trim(), username.trim()).toString(CryptoJS.enc.Utf8);
          if (decryptedPassword) {
            this.loginForm.patchValue({
              mobileno: username,
              password: decryptedPassword,
              rememberme: true
            });
          }
        } catch (e) {
          console.error("Error decrypting credentials", e);
        }
      }
    }
  }

  onSubmit() {
    if (this.loginForm.invalid)
      return;
    // Moved to success response

    const loginDto = new LoginDto({
      userName: this.loginForm.value.mobileno,
      password: this.loginForm.value.password,
      fcmToken: null
    });
    this._userServiceProxy.loginAuthenticate(loginDto).subscribe(response => {
      if (response.isSuccess) {
        // Save/Remove Remember Me data only on successful login
        if (this.loginForm.value.rememberme) {
          let data = CryptoJS.AES.encrypt(this.loginForm.value.password.trim(), this.loginForm.value.mobileno.trim()).toString();
          this._localStorageService.setData(LocalStorage.USERNAME, this.loginForm.value.mobileno);
          this._localStorageService.setData(LocalStorage.PASSWORD, data);
        }
        else {
          this._localStorageService.deleteData(LocalStorage.USERNAME);
          this._localStorageService.deleteData(LocalStorage.PASSWORD);
        }

        if (response.responseData.isPasswordChange == false)
          this._localStorageService.setData(LocalStorage.ISCHANGEPASSWORDOPENED, false);
        this._localStorageService.setData(LocalStorage.CURRENT_USER, response.responseData);
        this._localStorageService.setData(LocalStorage.TOKEN, response.responseData.token);
        this._localStorageService.setData(LocalStorage.PROFILE, response.responseData.profileImageUri);
        this.isAdmin = this._authenticationService.isAdministrator();

        if(this.returnUrl) {
          this._router.navigate([this.returnUrl]);
        }
        else {
          const url = this._router.serializeUrl(
            this._router.createUrlTree([this.isAdmin ? '/dashboard' : '/attendance'])
          );
          window.open(url, '_self');
        }
        

      } else {
        this._toasterService.toastWarning(response.errorMessage);
      }
    });

  }
  openForgetPasswordPopup() {
    this.forgetPasswordDialog = true;
  }
  SendResetLink() {
    if (!this.mailsuccessfully && this.userName.trim().length > 0) {
      this._userServiceProxy.sendResetPasswordRequest(this.userName).subscribe(res => {
        if (res.isSuccess) {
          this.userName = '';
          this.mailsuccessfully = true;
          setTimeout(() => {
            this.forgetPasswordDialog = false;
            this.mailsuccessfully = false;
          }, 10000);
        }
        else{
         let error = res.errorMessage 
         this.invalid = error;
          this.inValidUsername=true;
        }
      })
    }
  }
  ResetPassword() {
    this.resetPasswordInputDto.verificationCode = this.verficationCode;
    this._userServiceProxy.resetPassword(this.resetPasswordInputDto).subscribe(res => {
      if (res.isSuccess) {
        this.toasterMessage("success",res.responseData);
        this.resetPasswordDialog=false;
      }
    })
  }
  hideDialog() {
    this.resetPasswordDialog = false;
    window.location.href = "/";
  }
  hideForgetPasswordDialog() {
    this.forgetPasswordDialog = false;
    this.userName = '';
    this.mailsuccessfully = false;
    this.inValidUsername = false;
  }
  hideInvalidPopup() {
    this.inValidVerificationCode = false;
    this._router.navigate(['/'])
  }

  toasterMessage(type: any, msg: any, timeout: any =10000) {
    this.msg = msg;
    this.severity = type;
    this.inValidVerificationCode = true;
    setTimeout(() => {
      this.inValidVerificationCode = false;
      this._router.navigate(['/'])
    }, timeout);
  }
}
